"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringType = typeof ("");
var objectType = typeof ({});
var numberType = typeof (1);
var booleanType = typeof (true);
var functionType = typeof (function () { });
var type = {
    string: stringType,
    object: objectType,
    number: numberType,
    boolean: booleanType,
    function: functionType
};
exports.type = type;
var isString = function (o) {
    return typeof (o) === stringType;
};
exports.isString = isString;
var isObject = function (o) {
    return typeof (o) === objectType;
};
exports.isObject = isObject;
var isNumber = function (o) {
    return typeof (o) === numberType;
};
exports.isNumber = isNumber;
var isBoolean = function (o) {
    return typeof (o) === booleanType;
};
exports.isBoolean = isBoolean;
var isDate = function (o) {
    return o instanceof Date;
};
exports.isDate = isDate;
var isArray = function (o) {
    return Array.isArray(o);
};
exports.isArray = isArray;
var isFunction = function (o) {
    return typeof (o) === functionType;
};
exports.isFunction = isFunction;
